<template>
    <div ref="modal" class="llp-popup modal" tabindex="-1">
        <div :class="classNames" class="modal-dialog modal-dialog-centered">
            <div class="modal-content border border-2 border-primary">
                <div class="modal-header d-block">
                    <slot name="header"></slot>
                </div>
                <div class="modal-body">
                    <slot name="body"></slot>
                </div>
                <div class="modal-footer d-block">
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Modal} from 'bootstrap';

/**
 * Base Modal, inject and use as needed, unique to show per page
 */
export default {
  name: 'BaseModal',
  props: {
    classNames: {
      type: String,
      required: false,
      default: 'modal-lg',
    },
  },
  methods: {
    hideModal() {
      let modal = Modal.getOrCreateInstance(this.$refs.modal);
      modal.hide();
    },
  },
};
</script>
